var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-money-bill",
    "data-name": "Icon awesome-money-bill",
    d: "M32.3,4.5H1.7A1.684,1.684,0,0,0,0,6.167V22.833A1.684,1.684,0,0,0,1.7,24.5H32.3A1.684,1.684,0,0,0,34,22.833V6.167A1.684,1.684,0,0,0,32.3,4.5ZM2.55,22V18.667A3.367,3.367,0,0,1,5.95,22Zm0-11.667V7h3.4A3.367,3.367,0,0,1,2.55,10.333ZM17,19.5c-2.348,0-4.25-2.239-4.25-5s1.9-5,4.25-5,4.25,2.239,4.25,5S19.347,19.5,17,19.5ZM31.45,22h-3.4a3.367,3.367,0,0,1,3.4-3.333Zm0-11.667A3.367,3.367,0,0,1,28.05,7h3.4Z",
    transform: "translate(0 -4.5)",
    fill: "#fefefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/MoneyIcon.3721d2514095836d43ff3bb252971a63.svg";
export { ForwardRef as ReactComponent };